import ApplicationStore from '@stores/ApplicationStore';

class RootStore {

    constructor() {
        this.applicationStore = new ApplicationStore(this);
    }
}

export default new RootStore();